import { connect } from "react-redux";
import { getCategoryChildLinks } from "../../../state/modules/category";

import CategoryHeaderLinks from "./CategoryHeaderLinks";

const mapStateToProps = state => ({
  childLinks: getCategoryChildLinks(state)
});

export default require("../../../containers/withTogglePoint").default(connect(mapStateToProps)(CategoryHeaderLinks), require.context("./__variants__/", true, /^\.\/([^/]+\/){2}index\.js$/))
